import { Component, ViewChild, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Usuario } from '../../login/usuario';
import { AuthService } from '../../../core/services/auth.service';
import { TreinoService } from '../../../../services/treino.service';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { ToastService } from '../../../../services/toast.service';
import { faDumbbell, faHeartPulse, faPersonRunning } from '@fortawesome/free-solid-svg-icons';
import { DialogService } from '../../../../services/dialog.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TreinoModalComponent } from '../treino-modal/treino-modal.component';
import { TreinoItensModalComponent } from '../treino-itens-modal/treino-itens-modal.component';
import { TreinoUsuarioService } from '../../../../services/treino-usuario.service';
import { ExercicioService } from '../../../../services/exercicio.service';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';

interface Treino {
  id: number;
  nome: string;
  diaSemana: number;
  usuarioId: number;
}

@Component({
  selector: 'app-treino-gestao',
  templateUrl: './treino-gestao.component.html',
  styleUrl: './treino-gestao.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class TreinoGestaoComponent implements OnInit, OnDestroy {

  treinoForm!: FormGroup;

  faDumbbell = faDumbbell;
  faAbdominal = faPersonRunning; // melhor aproximação visual
  faCardio = faHeartPulse;

  treino: Treino = { id: 0, nome: '', diaSemana: 1, usuarioId: 0 };
  user: Usuario | null = null;

  dataSource = new MatTableDataSource<Treino>();

  isMobile = false;
  resizeListener!: () => void;

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  displayedColumns: string[] = ['id', 'nome', 'diaSemana', 'actions'];

  constructor(
    private fb: FormBuilder,
    private authorizeService: AuthService,
    private router: Router,
    private treinoService: TreinoService,
    private treinoUsuarioService: TreinoUsuarioService,
    private toastService: ToastService,
    private dialogService: DialogService,
    private modal: NgbModal
  ) { }

  ngOnInit(): void {
    this.user = this.authorizeService.getUser();

    if (!this.user) {
      this.router.navigate(['/login'], {
        queryParams: { retUrl: '/treino-gestao' }
      });
      return;
    }

    this.detectScreen();

    this.resizeListener = () => this.detectScreen();
    window.addEventListener('resize', this.resizeListener);

    this.getTreinosByUser();
    this.createForm(this.treino);
  }

  ngOnDestroy(): void {
    window.removeEventListener('resize', this.resizeListener);
  }

  detectScreen() {
    this.isMobile = window.innerWidth < 768;
  }

  getTreinosByUser() {
    this.treinoUsuarioService.getByUser().subscribe(res => {

      // 🔥 SEMPRE padroniza
      this.dataSource = new MatTableDataSource(res);

      // aguarda view
      setTimeout(() => {
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
      });

    });
  }

  createForm(t: Treino) {
    this.treinoForm = this.fb.group({
      id: [t.id],
      nome: [t.nome, Validators.required],
      diaSemana: [t.diaSemana, Validators.required],
      usuarioId: this.user?.id || 0,
    });
  }

  openTreinoModal(treino?: any) {
    const modalRef = this.modal.open(TreinoModalComponent, { size: 'lg' });

    modalRef.componentInstance.data = treino;

    modalRef.componentInstance.salvar.subscribe((result: Treino) => {
      this.saveTreino(result);
    });
  }

  async remover(id: number) {
    const confirmado = await this.dialogService.confirm('Deseja realmente excluir?', 'Tem certeza?');

    if (confirmado) {
      this.treinoService.delete(id).subscribe(() => {
        this.toastService.show('Excluído com sucesso', { type: 'success' });
        this.getTreinosByUser();
      });
    }
  }

  saveTreino(treinoData: Treino) {
    if (treinoData.id > 0) {
      this.treinoService.put(treinoData.id, treinoData).subscribe(() => {
        this.toastService.show('Atualizado', { type: 'success' });
        this.getTreinosByUser();
      });
    } else {
      this.treinoService.post(treinoData).subscribe(() => {
        this.toastService.show('Criado', { type: 'success' });
        this.getTreinosByUser();
      });
    }
  }

  openModalItens(treinoId: number, tipo: 'exercicio' | 'abdominal' | 'cardio') {

    this.treinoUsuarioService.getFullConfig(treinoId).subscribe(config => {

      const modalRef = this.modal.open(TreinoItensModalComponent, {
        size: 'xl',
        fullscreen: 'md-down',
        scrollable: true,
        backdrop: 'static',
        container: 'body'
      });

      modalRef.componentInstance.tipo = tipo;
      modalRef.componentInstance.config = config;

      modalRef.result
        .then((result: any[]) => {

          if (!result) return;

          const call =
            tipo === 'exercicio' ? this.treinoUsuarioService.salvarExercicios(treinoId, result) :
            tipo === 'abdominal' ? this.treinoUsuarioService.salvarAbdominais(treinoId, result) :
            this.treinoUsuarioService.salvarCardios(treinoId, result);

          call.subscribe(() => {
            this.toastService.show('Salvo com sucesso', { type: 'success' });
          });

        })
        .catch(() => { });
    });
  }
}